import { errorDispatcher, getOptionsQuery } from "../helpers";
import { appSetLoading } from "../store/actions/appAction";
import axios from "../axios/axios";
import { setTableData } from "../store/actions/dataTableAction";
import { store } from "store/store";

export const apiGetTaxFactors = ({ key }) => (dispatch, getState) => {
    // console.log({ pagination, token, key, sort, search, activeTab }, 'ddddddddddddddddddddddddd')
    const Token = getState().businessReducer.business?.token;
    const pagination = getState().paginationReducer
    let options = getOptionsQuery(pagination, {}, {});
    let url = `/moaddianInvoice/factors?state=${key}`;
    let params = {};

    dispatch(appSetLoading(true));
    axios
        .post(url, options, {
            headers: { Authorization: `Bearer ${Token}` },
            params,
        })
        .then((response) => {
            dispatch(setTableData(response.data.factors, response.data.paginate));
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};

export const apiGenerateCSR = (form, token, cb) => (dispatch, getState) => {
    const Token = token || getState().businessReducer.business?.token;

    dispatch(appSetLoading(true));
    axios
        .post('/moaddian/csr', form, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            cb(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};


export const checkRimaToken = async (callBack) => {
    const { dispatch, getState } = store
    const Token = getState().businessReducer.business?.token;
    axios.get("/moaddianInvoice/checkToken", { headers: { Authorization: `Bearer ${Token}` } }).then(res => {
        callBack(res.data.authorize)
    }).catch(err => {
        errorDispatcher(err, dispatch);
        callBack(false)
    })
}
// export const apiLoginRima = (callBack) => (dispatch, getState) => {
//     const Token = getState().businessReducer.business?.token;
//     const url = `/moaddianInvoice/login`
//     axios
//         .post(url, {}, {
//             headers: { Authorization: `Bearer ${Token}` },
//         })
//         .then((response) => {

//             callBack(response.data.token)
//             dispatch(appSetLoading(false));
//         })
//         .catch((error) => {
//             errorDispatcher(error, dispatch);
//         });

// }
export const apiSendToInvoice = (factorId) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;


    dispatch(appSetLoading(true));
    const url = `/moaddianInvoice/send/${factorId}`
    checkRimaToken(async (res) => {
        if (res) {
            axios
                .post(url, {}, {
                    headers: { Authorization: `Bearer ${Token}` },
                })
                .then((response) => {

                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        }
    })

}
export const apiSendToCancel = (factorId) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;


    dispatch(appSetLoading(true));
    const url = `/moaddianInvoice/cancelled/${factorId}`
    checkRimaToken(async (res) => {
        if (res) {

            axios
                .post(url, {}, {
                    headers: { Authorization: `Bearer ${Token}` },
                })
                .then((response) => {
                    const items = getState().dataTableReducer.items
                    const newItems = items.filter(x => x.id !== factorId)
                    const pagination = getState().paginationReducer
                    dispatch(setTableData(newItems, pagination));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        }
    })
}
export const apiEditModdian = (factorId) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;


    dispatch(appSetLoading(true));
    const url = `/moaddianInvoice/amended/${factorId}`
    checkRimaToken(async (res) => {
        if (res) {
            axios
                .post(url, {}, {
                    headers: { Authorization: `Bearer ${Token}` },
                })
                .then((response) => {
                    const items = getState().dataTableReducer.items
                    const newItems = items.filter(x => x.id !== factorId)
                    const pagination = getState().paginationReducer
                    dispatch(setTableData(newItems, pagination));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                });
        }
    })
}
export const apiMoaddianInquiry = (factorIds) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    const url = `/moaddianInvoice/Inquiry`
    checkRimaToken(async (res) => {
        if (res) {
            axios
                .post(url, { factorIds }, {
                    headers: { Authorization: `Bearer ${Token}` },
                })
                .then((response) => {

                    // const items = getState().dataTableReducer.items
                    // const newItems = items.filter(x => x.id !== factorId)
                    // const pagination = getState().paginationReducer
                    // dispatch(setTableData(newItems, pagination));
                    dispatch(appSetLoading(false));
                })
                .catch((error) => {
                    errorDispatcher(error, dispatch);
                })
        }
    })
}
export const apiRegisterTax = (form, token, cb) => (dispatch, getState) => {
    const Token = token || getState().businessReducer.business?.token;

    dispatch(appSetLoading(true));
    axios
        .post('/moaddian', form, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            cb(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });
};

export const apiMoadianInvoce = ({ params, callBack }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    axios
        .post('/moaddianInvoice/business', params, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            callBack(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });

}
export const apiEditModdianFactor = ({ params, callBack, factorId }) => (dispatch, getState) => {
    const Token = getState().businessReducer.business?.token;
    dispatch(appSetLoading(true));
    axios
        .post(`/moaddianInvoice/factor/update/${factorId}`, params, {
            headers: { Authorization: `Bearer ${Token}` },
        })
        .then((response) => {
            callBack(response.data)
            dispatch(appSetLoading(false));
        })
        .catch((error) => {
            errorDispatcher(error, dispatch);
        });

}

